export const state = () => {
  return {
    isOpen: false,
    activeSidebar: null,
    expandedNavigation: true,
    alertSets: []
  }
}

export const getters = {
  isOpen: (state) => {
    return state.isOpen
  },
  activeSidebar: (state) => {
    return state.activeSidebar
  },
  isExpandedNavigation: (state) => {
    return state.expandedNavigation
  },
  alertSets: (state) => {
    return state.alertSets
  }
}

export const mutations = {
  setIsOpen (state, newValue) {
    state.isOpen = newValue
  },
  setActiveSidebar (state, newValue) {
    state.activeSidebar = newValue

    if (newValue) {
      state.isOpen = true
    }
  },
  setExpandedNavigation (state, newValue) {
    state.expandedNavigation = newValue
  },
  setAlertSets (state, newValue) {
    state.alertSets = newValue
  }
}

export const actions = {
  fetchAlertSets ({ commit }, userId) {
    this.$axios
      .get(`v1/users/${userId}/alert-config-sets/`)
      .then((res) => {
        commit('setAlertSets', res.data.data)
      })
  }
}
